// ISBNNumberRegistration.jsx
import React from "react";

export default function ISBNNumberRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISBN Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISBN Number Registration Support
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports ISBN registration for authors and
            publishers, helping them navigate the national ISBN portal and align
            applications with official guidelines.[web:266][web:268][web:269]
          </p>
          <p className="text-gray-700">
            The service focuses on preparing accurate book and applicant details
            so that ISBNs can be allotted smoothly and used for distribution,
            cataloguing, and sales channels in India and abroad.[web:264][web:266][web:268]
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/46274/pexels-photo-46274.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Author working on a manuscript and book proofs"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISBN Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps applicants compile the core data and
              attachments that the Indian ISBN agency typically expects for book
              identification.[web:264][web:266][web:268]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Author or publisher details, including name, contact
                  information, and, where applicable, basic publisher
                  registration information.[web:265][web:266][web:268]
                </li>
                <li>
                  Manuscript information such as book title, subtitle, author
                  name, language, format (print/ebook), edition, and brief
                  description or subject.[web:264][web:265][web:268]
                </li>
                <li>
                  Identity proof of the applicant (for example, self‑attested
                  copy of Aadhaar, PAN, or similar photo ID) as generally
                  requested on the ISBN portal.[web:259][web:266][web:269]
                </li>
                <li>
                  Cover page or sample pages / title‑page files, where the
                  portal requires uploads to verify book details before
                  allotting an ISBN.[web:264][web:266][web:268]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm is positioned to help authors and publishers reduce
              friction in the ISBN process while staying within official norms
              and timelines.[web:266][web:268][web:269]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Knowledge of ISBN Norms
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on eligibility, separate ISBNs for different formats
                  or editions, and how the Indian ISBN system connects with
                  global book distribution.[web:265][web:268][web:269]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Timely Registration Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in preparing and submitting complete applications
                  so that processing timelines at the national agency are used
                  efficiently.[web:259][web:266][web:268]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  Continued support from planning ISBN requests through receipt
                  and proper use of the numbers on covers, copyright pages, and
                  catalog listings.[web:265][web:268][web:269]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
